<template>
  <div id="DmhF2F">
    <div
      class="dmh-f2f-container animate__animated animate__fadeIn"
      v-if="selectedView === 'landing'"
    >
      <h2 class="dmh-start-title brand-text mb-5">
        Please select the time & date that suits you best.
        <br />
        (Note: The proposed dates and times are typically for recurring
        appointments. Some flexibility may be required)
      </h2>
      <div
        v-if="areGetOptionsLoading"
        class="d-flex align-items-center justify-content-center"
      >
        <b-spinner class="brand-primary px-5 py-5"></b-spinner>
      </div>
      <div
        v-else-if="appointmentData"
        id="DmhSelect"
        class="border-brand-primary mb-5"
      >
        <LeafletMap
          class="py-5 mb-5 map-container"
          :lng="appointmentData.clinicianAddressCoordinates.lng"
          :lat="appointmentData.clinicianAddressCoordinates.lat"
          :draggable="false"
        />
        <div
          class="dmh-option border-brand-primary clickable active shadow"
          v-for="(option, index) in startOptions"
          :key="index"
          @click="selectOption(option)"
        >
          <div class="dmh-option-text " v-html="option.option_text"></div>
          <div class="dmh-option-next">
            <i
              class="fa-solid"
              :class="{
                'fa-circle-check': option.id !== 100,
                'fa-times-circle': option.id === 100,
                'brand-primary':
                  selectedOption && selectedOption.id === option.id
              }"
            ></i>
          </div>
        </div>
        <b-button
          variant="cta"
          size="lg"
          squared
          @click="handleSelection"
          :disabled="isConfirmOptionLoading || isRejectOptionLoading"
        >
          <b-spinner
            v-if="isConfirmOptionLoading || isRejectOptionLoading"
          ></b-spinner>
          <span v-else>Select</span>
        </b-button>
      </div>
      <div
        class="d-flex flex-row align-items-center justify-content-center w-100"
      >
        <div
          class="prompt-container d-flex flex-column align-items-center justify-content-center shadow w-100"
        >
          <p class="brand-text">
            If you select none, then the affiliate counsellor will suggest
            further options. You can also call us directly if you need support
            scheduling your appointment on the numbers below:
          </p>

          <div class="col-sm-12 phone-item mb-5">
            <div>
              UK:<a class="phone-link brand-tertiary ml-3">{{
                $store.getters.user.simplyhealth_membership
                  ? $store.getters.user.simplyhealth_membership.phone_numbers.uk
                  : "1800 903 542"
              }}</a>
            </div>
          </div>
          <div class="col-sm-12 phone-item mb-5">
            <div>
              IE:<a class="phone-link brand-tertiary ml-3">{{
                $store.getters.user.simplyhealth_membership
                  ? $store.getters.user.simplyhealth_membership.phone_numbers.ie
                  : "1800 903 542"
              }}</a>
            </div>
          </div>
          <div class="col-sm-12 phone-item mb-5">
            <div>
              International:<a class="phone-link brand-tertiary ml-3">{{
                $store.getters.user.simplyhealth_membership
                  ? $store.getters.user.simplyhealth_membership.phone_numbers
                      .international
                  : "1800 903 542"
              }}</a>
            </div>
          </div>
          <div class="col-sm-12 phone-item mb-5">
            <div>
              SMS:<a class="phone-link brand-tertiary ml-3">{{
                $store.getters.user.simplyhealth_membership
                  ? $store.getters.user.simplyhealth_membership.sms
                  : "1800 903 542"
              }}</a>
            </div>
          </div>
          <div class="col-sm-12 phone-item">
            <div>
              Whatsapp:<a class="phone-link brand-tertiary ml-3">{{
                $store.getters.user.simplyhealth_membership
                  ? $store.getters.user.simplyhealth_membership.whatsapp
                  : "1800 903 542"
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dmh-f2f-container animate__animated animate__fadeIn"
      v-else-if="selectedView === 'confirmSuccess'"
    >
      <h2 class="dmh-start-title brand-text mb-5">Confirmed!</h2>
      <div v-if="appointmentData && selectedOption" class="dmh-f2f-container">
        <div class="border-brand-primar pb-5">
          <img :src="appointmentData.clinicianImage" class="clinician-image" />
        </div>
        <p>
          Your session at <b>{{ appointmentData.clinicianAddress }}</b> with
          <b>{{ appointmentData.clinicianName }}</b> is confirmed for
          <b>{{ selectedOption.option_text }}</b>
        </p>
        <LeafletMap
          class="py-5 mb-5 map-container w-100"
          :lng="appointmentData.clinicianAddressCoordinates.lng"
          :lat="appointmentData.clinicianAddressCoordinates.lat"
          :draggable="false"
        />
      </div>
      <b-button variant="cta" size="lg" squared @click="$router.push('/')"
        >Back to home</b-button
      >
    </div>
    <div
      class="dmh-f2f-container animate__animated animate__fadeIn"
      v-else-if="selectedView === 'rejectSuccess'"
    >
      <h2 class="dmh-start-title brand-text mb-5">Rejected</h2>
      <div class="d-flex flex-column align-items-center" v-if="rejections > 1">
        <p class="pb-3">
          You have sucessfully rejected the options provided. You have rejected
          the options 2 times, please message the clinician to let them know why
          these options did not work for you.
        </p>
        <b-button
          variant="cta"
          size="lg"
          squared
          @click="
            $router.push('/message/' + $route.params.sessionId + '/reject')
          "
          >Send a message</b-button
        >
      </div>
      <div class="d-flex flex-column align-items-center" v-else>
        <p class="pb-3">
          You have sucessfully rejected the options provided. The clinician will
          provide another set of options within 48 hours.
        </p>
        <b-button variant="cta" size="lg" squared @click="$router.push('/')"
          >Back to home</b-button
        >
      </div>
    </div>
    <div
      class="dmh-f2f-container animate__animated animate__fadeIn"
      v-else-if="selectedView === 'error'"
    >
      <p class="pb-3">Something went wrong.</p>
      <b-button variant="cta" size="lg" squared @click="$router.push('/')"
        >Back to home</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import EventBus from "@/helpers/eventbus";
import LeafletMap from "@/components/LeafletMap.vue";

import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "F2F",
  components: {
    LeafletMap
  },
  data() {
    return {
      appointmentData: null,
      areGetOptionsLoading: false,
      isConfirmOptionLoading: false,
      isRejectOptionLoading: false,
      selectedView: "landing",
      rejections: 0,
      selectedOption: null,
      startOptions: [
        {
          id: 100,
          option_text: "None of these options suit me"
        }
      ]
    };
  },
  mounted() {
    this.getOptions();
    EventBus.$emit("updateNav", "f2f");
  },
  methods: {
    handleSelection() {
      if (this.selectedOption.id === 100) {
        this.rejectOptions();
      } else {
        this.confirmOption();
      }
    },
    async getOptions() {
      this.areGetOptionsLoading = true;
      try {
        const payload = {
          user_id: this.$store.getters.user_id,
          session_id: this.$route.params.sessionId
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/get-appointment-dates",
          payload,
          config.options
        );
        if (res.data.success) {
          this.startOptions.unshift({
            id: 3,
            option: res.data.option3,
            option_text: moment(res.data.option3).format(
              "dddd MMM Do [at] h:mma"
            )
          });
          this.startOptions.unshift({
            id: 2,
            option: res.data.option2,
            option_text: moment(res.data.option2).format(
              "dddd MMM Do [at] h:mma"
            )
          });
          this.startOptions.unshift({
            id: 1,
            option: res.data.option1,
            option_text: moment(res.data.option1).format(
              "dddd MMM Do [at] h:mma"
            )
          });
          this.appointmentData = res.data;
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.selectedView = "error";
        }
      } catch (err) {
        this.selectedView = "error";
      } finally {
        this.areGetOptionsLoading = false;
      }
    },
    async confirmOption() {
      if (this.isConfirmOptionLoading) {
        return;
      }
      this.isConfirmOptionLoading = true;
      try {
        const payload = {
          user_id: this.$store.getters.user_id,
          session_id: this.appointmentData.sessionId,
          delete_notification_id: this.$route.params.notificationId,
          confirmation_time: this.selectedOption.option
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/confirm-appointment-date",
          payload,
          config.options
        );
        if (res.data.success) {
          this.selectedView = "confirmSuccess";
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.selectedView = "error";
        }
      } catch (err) {
        this.selectedView = "error";
      } finally {
        this.isConfirmOptionLoading = false;
      }
    },
    async rejectOptions() {
      if (this.isRejectOptionLoading) {
        return;
      }
      this.isRejectOptionLoading = true;
      try {
        const payload = {
          user_id: this.$store.getters.user_id,
          delete_notification_id: this.$route.params.notificationId,
          session_id: this.appointmentData.sessionId
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/reject-appointment-dates",
          payload,
          config.options
        );
        if (res.data.success) {
          this.rejections = res.data.rejections;
          this.selectedView = "rejectSuccess";
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.selectedView = "error";
        }
      } catch (err) {
        this.selectedView = "error";
      } finally {
        this.isRejectOptionLoading = false;
      }
    },
    selectOption(option) {
      this.selectedOption = option;
    }
  },
  computed: {
    ...mapGetters(["user"])
  },
  watch: {
    "$route.params.sessionId": {
      handler: function() {
        this.getOptions();
      }
    }
  }
};
</script>
<style lang="less">
#DmhF2F {
  padding: 70px 0;
  min-height: 85vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  .map-container {
    border-radius: 16px;
  }
  b {
    font-family: "PlusJakartaSansBold";
  }
  p {
    font-size: 1.6rem;
    text-align: center;
    max-width: 400px;
  }
  .dmh-f2f-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;

    .prompt-container {
      margin-top: 20px;
      padding: 25px;
      max-width: 650px;
      border: 2px solid #e0e5f5;
      border-radius: 16px;
      background-color: white;

      p {
        font-size: 1.6rem;
        text-align: center;
        padding: 20px;
      }
    }

    .dmh-start-title {
      text-align: center;
      font-size: 3.8rem;
      letter-spacing: 0;
      font-family: "PlusJakartaSansBold";
    }

    .dmh-prompt-title {
      padding: 0;
      margin-top: 0;
      margin-bottom: 30px;
      text-align: center;
      font-size: 2.4rem;
      letter-spacing: 0;

      font-family: "PlusJakartaSansBold";
    }

    .phone-item {
      font-size: 1.8rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "PlusJakartaSansRegular";

      .phone-link {
        border-bottom: 1.5px solid;
        font-family: "PlusJakartaSansBold";
      }
    }

    .dmh-options-container {
      margin: 20px;
      max-width: 650px;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      width: 100%;
    }
    .dmh-confirm-container {
      display: flex;
      flex-direction: column;
      font-size: 1.6rem;
      background: #dedede;
      border-radius: 8px;
      padding: 15px;
      margin-bottom: 20px;
      .dmh-confirm-input {
        font-size: 2rem;
      }
      textarea {
        background: #dedede;
        border: none;
        width: 100%;
      }

      textarea:focus {
        outline-width: 0;
      }
    }

    .clinician-image {
      max-width: 80px;
      border-radius: 1000px;
      border: 4px solid inherit;
    }
  }

  .fa-times-circle.brand-primary {
    color: #ff4040 !important;
  }
}
</style>
